"use client";

/**
 * First-party plugin — @mml/narration.
 *
 * Phase 25-AB Task 15: wraps the Task 13 NarrationPanel as a plugin so
 * the editor shell can mount it via the Plugin SDK rather than via a
 * hard-coded import. The component itself is unchanged.
 */

import { NarrationPanel } from "@/components/narration/NarrationPanel";
import type { StudioPlugin } from "@/plugin-sdk";

export const narrationPlugin: StudioPlugin = {
	manifest: {
		id: "@mml/narration",
		version: "0.1.0",
		name: "Narration",
		description:
			"AI 나레이션 생성 — Mode A/B + 12 theme + 12 tone + Voice Clone",
		author: "makemonlab",
	},
	activate(api) {
		api.registerPanel({
			id: "narration-side",
			label: "나레이션",
			slot: "editor-side",
			render: () => <NarrationPanel />,
		});
		api.registerCommand({
			id: "narration.open",
			label: "나레이션 패널 열기",
			shortcut: "Ctrl+Alt+N",
			category: "Narration",
			handler: () => {
				api.notify("Narration panel triggered", "info");
			},
		});
	},
};
